"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Circle_1 = __importDefault(require("ol/style/Circle"));
const Fill_1 = __importDefault(require("ol/style/Fill"));
const Stroke_1 = __importDefault(require("ol/style/Stroke"));
const Style_1 = __importDefault(require("ol/style/Style"));
class StylesGenerator {
    get drawStyles() {
        const pointsStyle = new Circle_1.default({
            radius: 10,
            fill: new Fill_1.default({
                color: '#2a7346',
            }),
            stroke: new Stroke_1.default({
                color: '#fff',
                width: 3,
            }),
        });
        const drawingStyle = new Style_1.default({
            fill: new Fill_1.default({
                color: '#2a734650',
            }),
            stroke: new Stroke_1.default({
                color: '#eebb54',
                width: 6,
            }),
            image: pointsStyle,
        });
        const endStyle = new Style_1.default({
            fill: new Fill_1.default({
                color: [0, 0, 0, 0],
            }),
            stroke: new Stroke_1.default({
                color: '#fff',
                width: 6,
            }),
            image: pointsStyle,
        });
        const endStyleStep2 = new Style_1.default({
            fill: new Fill_1.default({
                color: [0, 0, 0, 0],
            }),
            stroke: new Stroke_1.default({
                color: '#fff',
                width: 6,
            }),
            image: pointsStyle,
        });
        return {
            pointsStyle: pointsStyle,
            drawingStyle: drawingStyle,
            endStyle: endStyle,
            endStyleStep2: endStyleStep2,
        };
    }
}
exports.default = StylesGenerator;
